module.exports = __webpack_public_path__ + "img/again.77474901.svg";